import { Component, OnInit } from '@angular/core';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { EMPTY, Subscription } from 'rxjs';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-device-new-peripheral-dashboard',
  templateUrl: './device-new-peripheral-dashboard.component.html',
  styleUrls: ['./device-new-peripheral-dashboard.component.scss']
})
export class DeviceNewPeripheralDashboardComponent implements OnInit {

  peripheralTypes;
  peripheralConnectionTypes;
  deviceInternalId;
  getPeripheralTypesSubscription: Subscription;

  constructor(private devicesDevicesService: DevicesDevicesService,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.deviceInternalId = this.activatedRoute.snapshot.params['deviceid'];
    this.setBreadcrumb();
    this.getPeripheralTypes();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-ethernet', 'devices-page.new peripheral', '/device/' + this.deviceInternalId, [new BRoute('devices-page.devices', '/devices'), new BRoute('devices-page.device detail', '/device/' + this.deviceInternalId), new BRoute('devices-page.new peripheral')]));
  }

  public getPeripheralTypes() {
    this.getPeripheralTypesSubscription = this.devicesDevicesService.listOfPeripheralTypes().pipe(
      tap(o => this.peripheralTypes = o.peripheralTypes),
      tap(o => this.peripheralConnectionTypes = o.peripheralConnectionTypes),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

}
